import React, { useState, useEffect} from 'react';
import { useSelector } from 'react-redux';
import { Field, useFormikContext } from 'formik';
import { temPerfilRBAC } from '../../../secutity/acl';
import { MODALIDADE, PERFIL } from '../../../common/Constants';
import axios from 'axios';
import { getHeaders } from '../../../request';
import { UF, MUNICIPIO, INSTITUICAO } from '../fieldNames';
import { SttAutocomplete } from '@stt-componentes/core';

const Municipio = ( props ) => {
	const { strings } = props;
    const { values } = useFormikContext();

    const [ufs, setUfs] = useState([]);
    const [municipios, setMunicipios] = useState([]);
    const [instituicoes, setInstituicoes] = useState([]);
    const [filtroPorLocal, setFiltroPorLocal] = useState(false);
    const [filtroPorRede, setFiltroPorRede] = useState(false);
    const [filtroPorFuncionario, setFiltroPorFuncionario] = useState(false);
    const [carregarUfs, setCarregarUfs] = useState(false);

    const user = useSelector(state => state.index.user);

    const UTILITARIOS_API_BASE_URL = global.gConfig.url_base_utilitarios;

    useEffect(() => {
        if (temPerfilRBAC(user, PERFIL.ADMINISTRADOR) || temPerfilRBAC(user, PERFIL.ADMINISTRADOR_ESTADUAL)) {
            setCarregarUfs(true);
            setFiltroPorLocal(true);
            setFiltroPorRede(true);
            setFiltroPorFuncionario(true);
        }
        if (temPerfilRBAC(user, PERFIL.MEDICO_SOLICITANTE)) {
            setCarregarUfs(true);
            setFiltroPorLocal(true);
        }
        if (temPerfilRBAC(user, PERFIL.VISUALIZADOR_REDE)) {
            setCarregarUfs(true);
            setFiltroPorLocal(true);
        }
    }, []);

    useEffect(() => {
        const ufSelecionada = values[UF];

        setMunicipios([]);

        if (filtroPorLocal && ufSelecionada) {
            axios
                .get(
                    `${UTILITARIOS_API_BASE_URL}/localizacao/cidade?id-estado=${ufSelecionada.id}`,
                    { headers: getHeaders() }
                )
                .then((response) => {
                    const { itens } = response.data.data;
                    setMunicipios(itens || []);
                })
                .catch(err => console.log(err));
        }
    }, [values[UF], filtroPorLocal]);

    const handleChangeMunicipio = (municipio) => {
        if (filtroPorLocal && municipio) {
            axios
                .get(`${UTILITARIOS_API_BASE_URL}/instituicao-equipamento?municipio=${municipio.id}&modalidade=${MODALIDADE.SIGLA}`, { headers: getHeaders() })
                .then((response) => {
                    if (response.data) {
                        const { itens } = response.data.data;
                        setInstituicoes(itens);
                    } else {
                        setInstituicoes([]);
                    }
                })
                .catch(err => console.log(err));
        }
    }

    return (
        <Field name={MUNICIPIO}>
            {({
                field: { name, value, onBlur },
                form: { setFieldValue }
            }) => (
                <SttAutocomplete
                    inputprops={{
                        name: name,
                        label: strings.municipio
                    }}
                    getOptionLabel={option => option && option.nome || ''}
                    getOptionSelected={(option, val) => option && val && option.id === val.id}
                    options={municipios}
                    value={value}
                    onBlur={onBlur}
                    onChange={(e, item) => {
                        setFieldValue(MUNICIPIO, item || null);
                        setFieldValue(INSTITUICAO, null);
                        handleChangeMunicipio(item);
                    }}
                    disabled={!values[UF]}
                />
            )}
        </Field>
    );
};

export default Municipio